'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getRandomId = function getRandomId() {
  return "popup".concat(Math.floor(Math.random() * Math.floor(100)));
};

exports.getRandomId = getRandomId;
//# sourceMappingURL=utils.js.map
